import { FormControl, FormLabel, Grid, GridItem, HStack, Input, VStack } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { FormError } from './error';
import { CreateOrgDataType } from './schema';

export type PersonalDetailsFormProps = {
  form: UseFormReturn<CreateOrgDataType>;
  // Set when the corresponding value arrived prefilled from a trusted source (e.g. the
  // authenticated user's own token) — locks the field so it can't be tampered with before the
  // account is created/linked, while still submitting its value normally.
  readOnlyFields?: {
    email?: boolean;
    firstName?: boolean;
    lastName?: boolean;
  };
};

export function PersonalDetailsForm({ form, readOnlyFields }: PersonalDetailsFormProps) {
  const {
    register,
    formState: { errors },
  } = form;
  return (
    <VStack w={'100%'} align="stretch" spacing={2} mt={6}>
      <Grid templateColumns="repeat(2, 1fr)" gap={4}>
        <GridItem>
          <FormControl isRequired isInvalid={Boolean(errors.email)}>
            <FormLabel>Email Address</FormLabel>
            <Input
              {...register('email')}
              placeholder="john.doe@example.com"
              isReadOnly={readOnlyFields?.email}
            />
            <FormError>{errors.email?.message}</FormError>
          </FormControl>
        </GridItem>
        <GridItem />
      </Grid>
      <HStack spacing={4}>
        <FormControl isRequired isInvalid={Boolean(errors.firstName)}>
          <FormLabel>First Name</FormLabel>
          <Input
            {...register('firstName')}
            placeholder="Owner First Name"
            isReadOnly={readOnlyFields?.firstName}
          />
          <FormError>{errors.firstName?.message}</FormError>
        </FormControl>
        <FormControl isRequired isInvalid={Boolean(errors.lastName)}>
          <FormLabel>Last Name</FormLabel>
          <Input
            {...register('lastName')}
            placeholder="Owner Last Name"
            isReadOnly={readOnlyFields?.lastName}
          />
          <FormError>{errors.lastName?.message}</FormError>
        </FormControl>
      </HStack>
    </VStack>
  );
}
